export const ANALYTICS_EVENTS = Object.freeze({
    LANDING_PAGE_VIEWED: 'landing_page_viewed', SIGNUP_STARTED: 'signup_started', SIGNUP_COMPLETED: 'signup_completed',
    LOGIN_COMPLETED: 'login_completed', LOGOUT_COMPLETED: 'logout_completed', APP_STORE_CLICKED: 'app_store_clicked',
    PLAY_STORE_CLICKED: 'play_store_clicked', SOCIAL_LINK_CLICKED: 'social_link_clicked', MOVIE_VIEWED: 'movie_viewed',
    TV_SHOW_VIEWED: 'tv_show_viewed', SEASON_VIEWED: 'season_viewed', COLLECTION_VIEWED: 'collection_viewed',
    PROFILE_VIEWED: 'profile_viewed', SEARCH_PERFORMED: 'search_performed', DISCOVER_FILTER_USED: 'discover_filter_used',
    DISCOVER_MEDIA_CARD_CTA_CLICKED: 'discover_media_card_cta_clicked',
    WATCHLIST_ADDED: 'watchlist_added', WATCHLIST_REMOVED: 'watchlist_removed', CHALLENGE_STARTED: 'challenge_started',
    CHALLENGE_QUESTION_ANSWERED: 'challenge_question_answered', CHALLENGE_COMPLETED: 'challenge_completed',
    CHALLENGE_ABANDONED: 'challenge_abandoned', CHALLENGE_FAILED: 'challenge_failed', COIN_EARNED: 'coin_earned',
    COIN_UPGRADED: 'coin_upgraded', LEGENDARY_EARNED: 'legendary_earned', COLLECTION_STARTED: 'collection_started',
    COLLECTION_PROGRESS_VIEWED: 'collection_progress_viewed', COLLECTION_ITEM_COMPLETED: 'collection_item_completed',
    COLLECTION_COMPLETED: 'collection_completed', COLLECTION_SHARED: 'collection_shared', CREATOR_COLLECTION_VIEWED: 'creator_collection_viewed',
    CREATOR_COLLECTION_STARTED: 'creator_collection_started', USER_FOLLOWED: 'user_followed', USER_UNFOLLOWED: 'user_unfollowed',
    ACHIEVEMENT_REACTED: 'achievement_reacted', ACHIEVEMENT_SHARED: 'achievement_shared', PROFILE_SHARED: 'profile_shared',
    NOTIFICATION_CLICKED: 'notification_clicked', COOLDOWN_RETURNED: 'cooldown_returned',
    PUBLIC_WATCHLIST_VIEWED: 'public_watchlist_viewed',
    GUEST_SESSION_STARTED: 'guest_session_started', GUEST_MEDIA_VIEWED: 'guest_media_viewed',
    GUEST_COLLECTION_VIEWED: 'guest_collection_viewed', GUEST_PUBLIC_PROFILE_VIEWED: 'guest_public_profile_viewed',
    GUEST_PUBLIC_WATCHLIST_VIEWED: 'guest_public_watchlist_viewed', GUEST_AUTH_GATE_SHOWN: 'guest_auth_gate_shown',
    GUEST_SIGNUP_STARTED: 'guest_signup_started', GUEST_LOGIN_STARTED: 'guest_login_started',
    GUEST_CONVERTED_TO_USER: 'guest_converted_to_user',
    MEDIA_FULL_CAST_OPENED: 'media_full_cast_opened',
    CURATED_LIST_VIEWED: 'curated_list_viewed',
    CURATED_LIST_MEDIA_CLICKED: 'curated_list_media_clicked',
    CURATED_LIST_WATCHLIST_ADDED: 'curated_list_watchlist_added',
    CURATED_LIST_BULK_WATCHLIST_ADDED: 'curated_list_bulk_watchlist_added',
    CURATED_LIST_VERIFY_CLICKED: 'curated_list_verify_clicked',
    CURATED_LIST_SHARED: 'curated_list_shared',
    // Media sharing (movie / show / season links — not coin sharing)
    MEDIA_SHARE_OPENED: 'media_share_opened',
    MEDIA_SHARE_COMPLETED: 'media_share_completed',
    MEDIA_SHARE_LINK_COPIED: 'media_share_link_copied',
    MEDIA_SHARED_LINK_OPENED: 'media_shared_link_opened',
    APP_OPEN_BANNER_VIEWED: 'app_open_banner_viewed',
    APP_OPEN_BANNER_OPEN_CLICKED: 'app_open_banner_open_clicked',
    APP_OPEN_BANNER_DISMISSED: 'app_open_banner_dismissed',
    APP_OPEN_ATTEMPTED: 'app_open_attempted',
    APP_OPEN_STORE_FALLBACK: 'app_open_store_fallback',
    AUTH_SCREEN_VIEWED: 'auth_screen_viewed',
    AUTH_METHOD_SELECTED: 'auth_method_selected',
    // My Lists (user-created custom lists)
    MY_LIST_CREATE: 'my_list_create', MY_LIST_RENAME: 'my_list_rename', MY_LIST_DELETE: 'my_list_delete',
    MY_LIST_OPEN: 'my_list_open', MY_LIST_ADD_ITEM: 'my_list_add_item', MY_LIST_REMOVE_ITEM: 'my_list_remove_item',
    MY_LIST_REORDER: 'my_list_reorder', MY_LIST_PROGRESS_VIEW: 'my_list_progress_view',
    ADD_TO_LIST_OPEN: 'add_to_list_open', ADD_TO_LIST_COMPLETE: 'add_to_list_complete',
    MY_LIST_SHARE_OPEN: 'my_list_share_open', MY_LIST_SHARED: 'public_list_share', MY_LIST_VISIBILITY_CHANGED: 'my_list_visibility_changed',
    SHARED_LIST_VIEWED: 'public_list_view',
    // Star ratings (docs/movie-ratings.md). _submitted/_updated/_removed fire
    // only after the API confirms. Guest attempts: guest_auth_gate_shown, reason 'rating'.
    RATING_STARTED: 'rating_started',
    RATING_SUBMITTED: 'rating_submitted',
    RATING_UPDATED: 'rating_updated',
    RATING_REMOVED: 'rating_removed',
    // Rating history on profiles (Phase 2B). Never usernames or ids.
    RATINGS_PROFILE_VIEWED: 'ratings_profile_viewed',
    RATINGS_SEE_ALL_CLICKED: 'ratings_see_all_clicked',
    RATINGS_HISTORY_VIEWED: 'ratings_history_viewed',
    RATINGS_SORT_CHANGED: 'ratings_sort_changed',
    // Custom Rankings (docs/custom-rankings.md). Never the ranking title or
    // anything personal: size, composition (movie | tv | mixed), source, logged_in.
    // Funnel events are also mirrored to the server log (analytics/rankingAnalytics.js).
    RANKING_EDITOR_OPENED: 'ranking_editor_opened',
    RANKING_CREATION_STARTED: 'ranking_creation_started',
    RANKING_CREATED: 'ranking_created',
    RANKING_EDITED: 'ranking_edited',
    RANKING_SHARED: 'ranking_shared',
    RANKING_VIEWED: 'ranking_viewed',
    RANKING_MAKE_YOUR_OWN_CLICKED: 'ranking_make_your_own_clicked',
    RANKING_MAKE_YOUR_OWN_COMPLETED: 'ranking_make_your_own_completed',
    RANKING_SIGNUP_STARTED: 'ranking_signup_started',
    RANKING_SIGNUP_COMPLETED: 'ranking_signup_completed',
    // Profile discovery (R4): once per profile view when rankings show; See All taps.
    RANKINGS_PROFILE_VIEWED: 'rankings_profile_viewed',
    RANKINGS_SEE_ALL_CLICKED: 'rankings_see_all_clicked',
    // My Top Movies (also mirrored to the server funnel log — see analytics/topMoviesAnalytics.js)
    TOP_MOVIES_OPENED: 'top_movies_opened',
    TOP_MOVIES_CREATION_STARTED: 'top_movies_creation_started',
    TOP_MOVIES_MOVIE_ADDED: 'top_movies_movie_added',
    TOP_MOVIES_COMPLETED: 'top_movies_completed',
    TOP_MOVIES_SAVED: 'top_movies_saved',
    TOP_MOVIES_SHARE_CLICKED: 'top_movies_share_clicked',
    TOP_MOVIES_IMAGE_EXPORTED: 'top_movies_image_exported',
    TOP_MOVIES_PUBLIC_PAGE_VIEWED: 'top_movies_public_page_viewed',
    TOP_MOVIES_CREATE_YOURS_CLICKED: 'top_movies_create_yours_clicked',
    TOP_MOVIES_SIGNUP_STARTED: 'top_movies_signup_started',
    TOP_MOVIES_SIGNUP_COMPLETED: 'top_movies_signup_completed',
    // Top Movies entry cards (mobile Home, web Discover, profile). `surface` says which.
    TOP_MOVIES_CARD_VIEWED: 'top_movies_card_viewed',
    TOP_MOVIES_CARD_CLICKED: 'top_movies_card_clicked',
    // Activation funnel (Phase 1)
    ONBOARDING_STARTED: 'onboarding_started',
    ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
    ONBOARDING_COMPLETED: 'onboarding_completed',
    ONBOARDING_SKIPPED: 'onboarding_skipped',
    // Onboarding diagnostics (src/diagnostics/onboardingDiagnostics.js)
    ONBOARDING_STEP_VIEWED: 'onboarding_step_viewed',
    ONBOARDING_STEP_ACTION: 'onboarding_step_action',
    ONBOARDING_STEP_ERROR: 'onboarding_step_error',
    ONBOARDING_RESUMED: 'onboarding_resumed',
    ONBOARDING_STEP_AUTO_SKIPPED: 'onboarding_step_auto_skipped',
    // Title picks during onboarding (GA4 only — not sent to the server log)
    TITLE_SELECTED: 'title_selected',
    TITLE_DESELECTED: 'title_deselected',
    QUIZ_SUBMIT_FAILED: 'quiz_submit_failed',
    // Post-first-coin Watchlist onboarding (retention step, not activation)
    WATCHLIST_ONBOARDING_STARTED: 'watchlist_onboarding_started',
    WATCHLIST_ONBOARDING_ITEM_ADDED: 'watchlist_onboarding_item_added',
    WATCHLIST_ONBOARDING_ITEM_REMOVED: 'watchlist_onboarding_item_removed',
    WATCHLIST_ONBOARDING_COMPLETED: 'watchlist_onboarding_completed',
    WATCHLIST_ONBOARDING_SKIPPED: 'watchlist_onboarding_skipped',
    QUIZ_START_REQUESTED: 'quiz_start_requested',
    QUIZ_START_BLOCKED: 'quiz_start_blocked',
    QUIZ_START_FAILED: 'quiz_start_failed',
    QUIZ_SUBMIT_BLOCKED: 'quiz_submit_blocked',
    // Post-quiz Review Missed Questions (no question/answer text is ever sent)
    QUIZ_REVIEW_OPENED: 'quiz_review_opened',
    QUIZ_MISSED_QUESTION_REPORT_STARTED: 'quiz_missed_question_report_started',
    QUIZ_MISSED_QUESTION_REPORT_SUBMITTED: 'quiz_missed_question_report_submitted',
    EMAIL_VERIFICATION_PROMPT_SHOWN: 'email_verification_prompt_shown',
    EMAIL_VERIFICATION_RESEND: 'email_verification_resend',
    // Verification recovery around a blocked quiz. result: sent | already_verified
    // | rate_limited | failed; checked result: verified | not_verified | error.
    EMAIL_VERIFICATION_RESEND_RESULT: 'email_verification_resend_result',
    EMAIL_VERIFICATION_CHECKED: 'email_verification_checked',
    EMAIL_VERIFICATION_DISMISSED: 'email_verification_dismissed',
    QUIZ_RESUMED_AFTER_VERIFICATION: 'quiz_resumed_after_verification',
    // First quiz before email verification: the coin is held until verified.
    PENDING_COIN_EARNED: 'pending_coin_earned',
    EMAIL_VERIFIED: 'email_verified',
    PENDING_COIN_CLAIMED: 'pending_coin_claimed',
    HOME_NEXT_UP_SHOWN: 'home_next_up_shown',
    HOME_NEXT_UP_CLICKED: 'home_next_up_clicked',
    // Home feed (docs/home-feed.md). Params: tab, card_type, source, position,
    // reason_code, media_type — never titles, usernames or ids. Impressions fire
    // once per card per feed load, only after the card is at least half visible.
    HOME_FEED_TAB_SELECTED: 'home_feed_tab_selected',
    HOME_FEED_CARD_IMPRESSION: 'home_feed_card_impression',
    HOME_FEED_RANKING_OPENED: 'home_feed_ranking_opened',
    HOME_FEED_TITLE_OPENED: 'home_feed_title_opened',
    HOME_FEED_RECOMMENDATION_CLICKED: 'home_feed_recommendation_clicked',
    HOME_FEED_EDITORIAL_OPENED: 'home_feed_editorial_opened',
    HOME_FEED_WATCHLIST_ADDED: 'home_feed_watchlist_added',
    HOME_FEED_DISCOVER_PEOPLE_CLICKED: 'home_feed_discover_people_clicked',
    // Seasonal / limited-time collections
    SEASONAL_COLLECTION_VIEWED: 'seasonal_collection_viewed',
    SEASONAL_COLLECTION_REWARD_EARNED: 'seasonal_collection_reward_earned',
    SEASONAL_COLLECTION_EXPIRED_VIEW: 'seasonal_collection_expired_view',
    // Profile picture (curated avatar library / own photo). Never image URLs or contents.
    PROFILE_AVATAR_PICKER_OPENED: 'profile_avatar_picker_opened',
    PROFILE_AVATAR_SELECTED: 'profile_avatar_selected',
    PROFILE_PHOTO_UPLOADED: 'profile_photo_uploaded',
    PROFILE_AVATAR_REMOVED: 'profile_avatar_removed',
    PROFILE_AVATAR_LOCKED_TAPPED: 'profile_avatar_locked_tapped',
    // Challenge loader animation (once per challenge load, never per loop).
    CHALLENGE_LOADER_SHOWN: 'challenge_loader_shown',
    CHALLENGE_LOADER_FAILED: 'challenge_loader_failed',
});
